import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'

//import Grilla from './grilla'
import {LoadingComponent} from 'recupero-comunes'

import { configuracionFormAction85, obtenerCuotas } from '../../store/actions/declaracion-pago-action'
import PagoCuotas from './pagoCuotas'
import CalendarioCuotas from './calendarioCuotas'
import PagoTotal from './pagoTotal'

const DeclaracionPago = ({ handleClose, idCaso, idImplicado, idOrganizacionCaso}) => {
    const [loading,setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves} = data_recepciona
    const dispatch=useDispatch()

    const data_decPago = useSelector((state) => state.declaracionPagoReducer)
    const { cfg_form85, datosDecPago} = data_decPago

    const [esPagoParcial, setEsPagoParcial]=useState(false)

    useEffect(() => {   
        if (datosDecPago && datosDecPago?.datosDecPago['formaPago']) {
            setEsPagoParcial(datosDecPago?.datosDecPago['formaPago'] == '253002');//Pago en Cuotas
        }
    }, [datosDecPago])
    
    useEffect(() => {     

        dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
      
      }, [dispatch])
      useEffect(() => {
        if(llaves){  
            setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 85
        })).toString('base64')
        dispatch(configuracionFormAction85(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idCaso": llaves && llaves['idCaso'],
                "idImplicado": llaves && llaves['idImplicado']
            })).toString('base64')
            dispatch(obtenerCuotas(query))
        })
       
        .then(()=>{
            setLoading(false)
        })
    
    }
    }, [dispatch,llaves])
    return (
        <>
        <LoadingComponent show={loading}/>

            {esPagoParcial ? (
            <>
                <PagoCuotas handleClose={handleClose} />
                <CalendarioCuotas />
            </>
            ) : (
                <PagoTotal handleClose={handleClose} />
            )}
        </>
    )
}

export default DeclaracionPago
